import React, { useMemo, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Badge } from "../../components/ui/badge";
import ResourceManager, { useResourceList } from "../../components/admin/ResourceManager";
import { fmtDate } from "../../lib/resources";

function PasswordDisplay({ value }) {
  const [show, setShow] = useState(false);
  if (!value) return <span className="text-[#64748B]">—</span>;
  return (
    <div className="flex items-center gap-2">
      <span className="font-mono text-xs">{show ? value : "••••••"}</span>
      <button type="button" onClick={() => setShow(!show)} className="text-[#64748B] hover:text-white transition-colors" title={show ? "Hide password" : "Show password"}>
        {show ? <EyeOff size={14} /> : <Eye size={14} />}
      </button>
    </div>
  );
}

export default function ManageSchoolAdmins() {
  const [schools, reloadSchools] = useResourceList("schools");
  const schoolOpts = useMemo(() => schools.map((s) => ({ value: s.name, label: `${s.name}${s.code ? ` (${s.code})` : ""}` })), [schools]);

  return (
    <ResourceManager
      kind="school-admins"
      selectable={true}
      eyebrow="School Admins"
      title="School Admins"
      subtitle="Assign admins to schools. New schools appear here automatically."
      excelHint="Columns: name, email, mobile, school_name, password"
      onDataChanged={reloadSchools}
      fields={[
        { key: "avatar_url", label: "Profile Image", type: "image" },
        { key: "school_name", label: "School", type: "select", options: schoolOpts, placeholder: "Select school", required: true },
        { key: "name", label: "Admin Name", type: "text", required: true },
        { key: "email", label: "Email", type: "email", required: true },
        { key: "mobile", label: "Mobile Number", type: "tel", placeholder: "+1 555 0100" },
        { key: "password", label: "Password", type: "password", minLength: 6, placeholder: "Login password (min 6 chars)" },
      ]}
      columns={[
        { key: "name", label: "Admin" },
        { key: "school_name", label: "School" },
        { key: "email", label: "Email" },
        { key: "mobile", label: "Mobile" },
        { key: "password", label: "Password", render: (r) => <PasswordDisplay value={r.password} /> },
        { key: "status", label: "Status", render: (r) => (
          <Badge variant="outline" className={r.status === "disabled" ? "border-red-400/40 text-red-300 bg-red-500/10" : "border-emerald-400/40 text-emerald-300 bg-emerald-500/10"}>
            {r.status || "active"}
          </Badge>
        )},
        { key: "created_at", label: "Date", render: (r) => fmtDate(r.created_at) },
      ]}
    />
  );
}
